import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEnvelope,
  faMapMarkerAlt,
  faShieldHalved,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faWhatsapp,
  faYoutube,
  faInstagram,
  faBlogger,
  faTiktok,
} from "@fortawesome/free-brands-svg-icons";

library.add(
  faMapMarkerAlt,
  faWhatsapp,
  faEnvelope,
  faInstagram,
  faFacebookF,
  faYoutube,
  faBlogger,
  faShieldHalved,
  faFileContract
);

const TopNav = ({ isActive }) => {
  return (
    <nav aria-label="Top Navigation" className="top_menu" id="top_menu">
      <ul className="top_menu__ul">
        <li className="top_menu__ul__li">
          <address className="top_menu__ul__li__leftInfo">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            <span>Islamabad  & Istanbul</span>
          </address>
        </li>

        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__leftInfo">
            <Link
              aria-label="Privacy Policy | Legal"
              to="/legal/privacy-policy"
            >
              <FontAwesomeIcon icon={faShieldHalved} />
              <span>Privacy Policy</span>
            </Link>
          </div>
        </li>
        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__leftInfo">
            <Link
              aria-label="Terms and Conditions | Legal"
              to="/legal/terms-and-conditions"
            >
              <FontAwesomeIcon icon={faFileContract} />
              <span>Terms and Conditions</span>
            </Link>
          </div>
        </li>
        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__leftInfo">
            <FontAwesomeIcon icon={faEnvelope} />
            <span>seedtotree.info@gmail.com</span>
          </div>
        </li>
      </ul>

      <ul className="top_menu__ul">
        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__rightInfo">
            <Link
              aria-label="Follow us on Tiktok"
              to="https://www.tiktok.com/@seedtotree.info"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* <FontAwesomeIcon icon={faTiktok} spin /> */}
              <FontAwesomeIcon icon={faTiktok}  />
              <span>Follow us on Tiktok</span>
            </Link>
          </div>
        </li>
        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__rightInfo">
            <Link
              aria-label="Follow us on Facebook"
              to="https://www.facebook.com/seedtotree.info"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebookF}  />
              <span>Follow us on Facebook</span>
            </Link>
          </div>
        </li>
        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__rightInfo">
            <Link
              aria-label="Follow us on Whatsapp Channel"
              to="https://wa.me/+923405021470"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faWhatsapp}  />
              <span>Follow us on Whatsapp Channel</span>
            </Link>
          </div>
        </li>
        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__rightInfo">
            <Link
              aria-label="Follow us on Instagram"
              to="https://www.instagram.com/seedtotree.info"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram}  />
              <span>Follow us on Instagram</span>
            </Link>
          </div>
        </li>

        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__rightInfo">
            <Link
              aria-label="Follow us on Youtube"
              to="https://www.youtube.com/@seedtotree-info/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube}  />
              <span>Follow us on Youtube</span>
            </Link>
          </div>
        </li>

        <li className="top_menu__ul__li">
          <div className="top_menu__ul__li__rightInfo">
            <Link
              aria-label="Follow us on Blogger"
              to="https://seedtotreeacademy.blogspot.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faBlogger}  />
              <span>Follow us on Blogger</span>
            </Link>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default TopNav;
